import { SideswipeFooter } from "@wf-components/footer-react";

import type { Locale } from "~/generated/schema.graphcms";

export const Footer = ({ locale, domain }: { locale: Locale; domain: string | undefined }) => {
	return <SideswipeFooter locale={locale} domain={domain} disableNewsletter={false} />;
};
